<template>
  <CustomModal
    v-model:visible="isVisible"
    :title="title"
    :width="width"
    :position="position"
  >
    <div
      class="text-sm text_color break-words overflow-wrap-anywhere whitespace-normal"
    >
      {{ message }}
    </div>

    <template #footer>
      <div class="flex gap-2">
        <a-button class="secondary_medium" @click="handleCancel">
          {{ cancelText }}
        </a-button>
        <a-button
          :class="confirmButtonClass"
          @click="handleConfirm"
          :loading="loading"
        >
          {{ loading ? loadingText : confirmText }}
        </a-button>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { computed } from "vue";
import CustomModal from "@/src/components/CustomModal.vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Delete Item",
  },
  message: {
    type: String,
    default: "Are you sure you want to delete this item?",
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "default",
    validator: (value) => ["default", "delete", "danger"].includes(value),
  },
  confirmText: {
    type: String,
    default: "Confirm",
  },
  cancelText: {
    type: String,
    default: "Cancel",
  },
  loadingText: {
    type: String,
    default: "Processing...",
  },
  position: {
    type: String,
    default: "center",
    validator: (value) => ["top", "center", "bottom"].includes(value),
  },
  width: {
    type: String,
    default: "450px",
  },
});

const emit = defineEmits(["update:visible", "confirm", "cancel"]);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

const confirmButtonClass = computed(() => {
  if (props.type === "delete" || props.type === "danger") {
    return "danger_medium";
  }
  return "primary_medium";
});

const handleConfirm = () => {
  emit("confirm");
};

const handleCancel = () => {
  emit("cancel");
  isVisible.value = false;
};
</script>
